module.exports = __webpack_public_path__ + "static/media/wanted-word-bounty-40 percent.96c6eb4b.png";